import React, { createContext, useContext, useState, useCallback } from 'react';
import translations from './translations';

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [taal, setTaal] = useState(() => {
    try { return localStorage.getItem('sw_taal') || 'nl'; } catch(e) { return 'nl'; }
  });

  const wisselTaal = useCallback((nieuweTaal) => {
    if (translations[nieuweTaal]) {
      setTaal(nieuweTaal);
      try { localStorage.setItem('sw_taal', nieuweTaal); } catch(e) {}
    }
  }, []);

  const t = useCallback((key, fallback) => {
    const lang = translations[taal] || translations.nl;
    return lang[key] || translations.nl[key] || fallback || key;
  }, [taal]);

  return (
    <LanguageContext.Provider value={{ taal, wisselTaal, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
}

export default LanguageContext;
